import apiAxios from '../../services/axios/axiosConfig';

async function register(data: {
  email: string;
  password: string;
}) {
  const response = await apiAxios.post<void>('/api/v1/register', data, {
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data;
}

export default register;
